import { booleanAttribute, ChangeDetectionStrategy, Component, forwardRef, input, model } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomControl } from '../custom-control/custom-control.component';

@Component({
    selector: 'tran-checkbox',
    imports: [ReactiveFormsModule, TranslatePipe],
    templateUrl: './checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ]
})
export class CheckboxComponent extends CustomControl<boolean> {
    public readonly label = input.required<string>();
    public readonly labelVariant = input<'primary' | 'secondary'>('primary');
    public readonly readonly = input(false, { transform: booleanAttribute });
    public readonly isChecked = model<boolean>(false);

    public override writeValue(value: boolean): void {
        super.writeValue(value);
        this.isChecked.set(value);
    }

    protected onCheckboxChange(event: Event): void {
        const checked = (event.target as HTMLInputElement).checked;
        this.isChecked.set(checked);
        this.onChange(checked);
        this.onTouch();
    }
}
